module.exports = __webpack_public_path__ + "static/media/green_nebula_skybox_DN.5ff8e952.png";